// src/stats/infrastructure/ui-services/parametersUiService.ts

import type { Parameter, ParameterCode } from "~/src/stats/domain/models/Parameter";
//import type { ParameterDTO } from "~/src/stats/infrastructure/DTO/ParameterDTO";
import parametersEs from "~/src/stats/datasources/parameters_es.json";
import parametersEn from "~/src/stats/datasources/parameters_en.json";
import parametersFr from "~/src/stats/datasources/parameters_fr.json";
import parametersPt from "~/src/stats/datasources/parameters_pt.json";
import parametersDe from "~/src/stats/datasources/parameters_de.json";
import parametersIt from "~/src/stats/datasources/parameters_it.json";

const parametersMap: { [key: string]: Parameter[] } = {
  de: parametersDe as Parameter[],
  en: parametersEn as Parameter[],
  es: parametersEs as Parameter[],
  fr: parametersFr as Parameter[],
  it: parametersIt as Parameter[],
  pt: parametersPt as Parameter[],
};

interface ParametersUiService {
  getParameters: () => Promise<Parameter[] | undefined>;
  findParameter: (parameterCode: ParameterCode, parameters: Parameter[]) => Parameter | undefined;
}

export default (): ParametersUiService => {
  return {
    getParameters,
    findParameter,
  };
};

async function getParameters(): Promise<Parameter[] | undefined> {
  const { locale } = useI18n();
  // if (locale.value === "en") {
  //   return parametersEn as Parameter[];
  // } else {
  //   return parametersEs as Parameter[];
  // }

  return parametersMap[locale.value] || parametersMap["en"];

  /*
  try {
    const { data: parameters, error } = await useFetch<ParameterDTO[]>("/api/kama/parameters");

    if (error.value) {
      throw createError({
        ...error.value,
        message: "Could not fetch parameters.",
      });
    }

    if (parameters.value) {
      return parameters.value;
    } else {
      new Error("Parameters data is null.");
    }
  } catch (e) {
    console.error(e);
  }
   */
}

function findParameter(parameterCode: ParameterCode, parameters: Parameter[]): Parameter | undefined {
  return parameters.find(p => p.code === parameterCode);
}
